export interface Strings {
  nav: {
    pricing: string;
    trust: string;
    signin: string;
    startFree: string;
    menu: string;
    close: string;
    home: string;
  };
  home: {
    placeholderTitle: string;
    placeholderSub: string;
  };
}

export const STRINGS_EN: Strings = {
  nav: {
    pricing: 'Pricing',
    trust: 'Trust',
    signin: 'Log in',
    startFree: 'Start free',
    menu: 'Menu',
    close: 'Close',
    home: 'Prinotes',
  },
  home: {
    placeholderTitle: 'Prinotes',
    placeholderSub: 'Scaffold home — Hero arrives in Phase 0 Group F.',
  },
};

/** @deprecated Use `Strings` directly; alias kept for backward import compatibility. */
export type StringsEN = Strings;
